/**
 * theme-init.js — SCRIPT ANTI-FLASH
 *
 * Inserir no <head> do public/index.html ANTES de qualquer <link> de CSS.
 * Roda síncrono — bloqueia render intencionalmente para evitar flash de tema errado.
 *
 * Cole o conteúdo do bloco <script> diretamente no index.html.
 * Não importar como módulo — precisa rodar antes do React montar.
 *
 * Lógica:
 *  1. Lê localStorage('radio-ai-theme')
 *  2. Se não existir, detecta preferência do OS via matchMedia
 *  3. Aplica data-theme no <html> antes do primeiro paint
 *  4. ThemeToggle no painel grava no localStorage e chama applyTheme()
 */

// ─── Versão para copiar no <head> do index.html ────────────────────────────────
/*
<script>
  (function () {
    var saved = localStorage.getItem('radio-ai-theme')
    var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    var theme = saved || (prefersDark ? 'dark' : 'light')
    document.documentElement.setAttribute('data-theme', theme)
  })()
</script>
*/

// ─── Funções exportadas para o ThemeToggle ─────────────────────────────────────

const STORAGE_KEY = 'radio-ai-theme'

/**
 * Lê o tema atual — 'dark' | 'light'
 * Prioridade: localStorage > OS > 'dark' (fallback)
 */
export function getTheme() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'dark' || saved === 'light') return saved
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

/**
 * Aplica um tema — persiste no localStorage e atualiza o DOM
 */
export function applyTheme(theme) {
  if (theme !== 'dark' && theme !== 'light') {
    console.warn('[theme] valor inválido:', theme)
    return
  }
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem(STORAGE_KEY, theme)
}

/**
 * Alterna entre dark e light
 */
export function toggleTheme() {
  const current = getTheme()
  applyTheme(current === 'dark' ? 'light' : 'dark')
}

/**
 * Remove override manual — volta a seguir o OS
 */
export function resetToOS() {
  localStorage.removeItem(STORAGE_KEY)
  const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  document.documentElement.setAttribute('data-theme', theme)
}

/**
 * Uso no ThemeToggle:
 *
 *   import { getTheme, toggleTheme } from '../theme/theme-init'
 *
 *   function ThemeToggle() {
 *     const [theme, setTheme] = useState(getTheme)
 *     const handleToggle = () => {
 *       toggleTheme()
 *       setTheme(getTheme())
 *     }
 *     return <button onClick={handleToggle}>{theme === 'dark' ? '☀' : '☾'}</button>
 *   }
 */
